import BookIcon from "@mui/icons-material/Book";
import React from "react";

const TempMt = [
  [
    "Mock Test Save Records",
    "/admin/temp-mt",
    <BookIcon sx={{ fontSize: "2rem", ml: "0.3rem" }}></BookIcon>,
  ],
];

export default TempMt;
